module.exports = __webpack_public_path__ + "img/symbol_6.9e594fca.png";